import * as angular from 'angular';

import { WidgetBase } from '../../widgets';
import { Helper } from '../../common';
import { GroupStatesConfiguration } from './groupsTree.configuration';
import { GroupsTreeWidgetDefinition as definition } from './groupsTree.definition';

export class GroupsTreeWidget extends WidgetBase {
    baseType = definition.baseType;
    col = 0;
    configuration: GroupStatesConfiguration;
    guid: string;
    hasExtendedProperties = false;
    highlights = definition.highlights;
    icon = definition.icon;
    name = definition.title;
    row = 0;
    sizeX = 6;
    sizeY = 6;
    type = definition.type;

    constructor() {
        super();
        this.guid = Helper.getGuid();
        this.configuration = new GroupStatesConfiguration();
    }
}